import request from '@/utils/request'

/**
 * 获取车牌号统计数据
 * @param {Object} params - 查询参数
 * @param {String} params.startDate - 开始日期
 * @param {String} params.endDate - 结束日期
 * @param {Number} params.stationId - 气站ID
 * @param {String} params.plateNumber - 车牌号
 */
export function getLicensePlateStats(params) {
  return request({
    url: '/payment/license-plate-stats',
    method: 'get',
    params
  })
}

/**
 * 导出车牌号统计数据
 * @param {Object} params - 查询参数
 */
export function exportLicensePlateStats(params) {
  return request({
    url: '/payment/license-plate-stats/export',
    method: 'get',
    params,
    responseType: 'blob'
  })
}
